import { Action, Dispatch } from 'redux';
import { IAppState } from './reducers';
import { ActionType as ValidationAction } from './validation';
import { Validation } from '../constants/validation';
import { getProductNamesByOrgId } from '../utils/user';
import { KeyRoleUserVaultRoles } from './user/userOrgRole';

export enum ValidationKey {
  Email = 'SupportEmailDialogInput',
}

export const ValidationRules = {
  Email: [Validation.NOT_EMPTY, Validation.EMAIL],
};

export enum ActionType {
  Toggle = 'SupportEmailDialog.Toggle',
  UpdateEmail = 'SupportEmailDialog.UpdateEmail',
  UpdateMessage = 'SuportEmailDialog.UpdateMessage',
  ClearAll = 'SupportEmailDialog.ClearAll',
  UpdateProducts = 'SupportEmailDialog.UpdateProducts',
}

export interface ISupportEmailDialogAction extends Action<ActionType> {
  payload?: any;
}

export interface IState {
  isOpen: boolean;
  email: string;
  message: string;
  products: string[];
}

const INITIAL_STATE: IState = {
  isOpen: false,
  email: '',
  message: '',
  products: [],
};

export default function reducer(state: IState = INITIAL_STATE, action: ISupportEmailDialogAction) {
  switch (action.type) {
    case ActionType.Toggle:
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    case ActionType.UpdateEmail:
      return {
        ...state,
        email: action.payload.email,
      };
    case ActionType.UpdateMessage:
      return {
        ...state,
        message: action.payload.message,
      };
    case ActionType.UpdateProducts:
      return {
        ...state,
        products: action.payload,
      };
    case ActionType.ClearAll:
      return {
        ...INITIAL_STATE,
        products: state.products,
      };
    default:
      return state;
  }
}

export const toggleEmailDialog = () => async (
  dispatch: Dispatch,
  getState: () => IAppState,
) => {
  dispatch({
    type: ValidationAction.ClearErrors,
    key: ValidationKey.Email,
  });
  dispatch({
    type: ActionType.Toggle,
  });
};

export const updateEmail = (email: string) => ({
  type: ActionType.UpdateEmail,
  payload: {
    email,
  },
});

export const updateMessage = (message: string) => ({
  type: ActionType.UpdateMessage,
  payload: {
    message,
  },
});

export const clearAll = () => ({
  type: ActionType.ClearAll,
});

export const getProducts = () => async (
  dispatch: Dispatch,
  getState: () => IAppState,
) => {
  const state = getState();
  const userVaultRoles = state.user?.userOrgRole?.loginAs?.[KeyRoleUserVaultRoles];
  const userOrgId = userVaultRoles?.[0]?.orgId;
  const products = await getProductNamesByOrgId([userOrgId]);
  dispatch({
    type: ActionType.UpdateProducts,
    payload: products,
  });
};
